import { render } from "./dots.vue?vue&type=template&id=33fb5320"
import script from "./dots.vue?vue&type=script&lang=js"
export * from "./dots.vue?vue&type=script&lang=js"

import exportComponent from "/Users/l333n/Development/lennarthakker/lennarthakker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__